var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00136 2.07875C9.9632 0.440678 12.7905 0.603847 14.5669 2.45829C16.365 4.33686 16.5145 7.364 14.7686 9.34969C13.6892 10.5777 12.4074 11.9661 11.2349 13.0522C10.65 13.5942 10.0766 14.0745 9.55834 14.4249C9.07535 14.7513 8.51899 15.0492 8 15.0492C7.48101 15.0492 6.92465 14.7513 6.44167 14.4249C5.92335 14.0745 5.35002 13.5942 4.76513 13.0522C3.59264 11.9661 2.31079 10.5777 1.23136 9.34969C-0.514459 7.364 -0.365011 4.33686 1.43312 2.45829C3.20951 0.603847 6.0368 0.440678 7.99864 2.07875L8 2.08017L8.00136 2.07875Z",
    fill: "#FC6621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.9a0532357dbdc3f23e6dc8cff11960f1.svg";
export { ForwardRef as ReactComponent };